import { render, staticRenderFns } from "./carousel-brands-cmp.vue?vue&type=template&id=0918eeda&scoped=true"
import script from "./carousel-brands-cmp.vue?vue&type=script&lang=js"
export * from "./carousel-brands-cmp.vue?vue&type=script&lang=js"
import style0 from "./carousel-brands-cmp.vue?vue&type=style&index=0&id=0918eeda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0918eeda",
  null
  
)

export default component.exports